const state = {
  user: {
    name: '',
    id: ''
  },
	baseUrl: 'http://weixinapi.cvddr.com'
  // baseUrl: 'http://nourishapi-test.healthme.cn'
  // baseUrl:'http://jxapi-test.cvddr.cn'
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js